import type { IGhHostView } from '../gpthelp-host-contract';
import { clampText } from './card-text';
import type { ICardFormat } from './card-text';

/** «Cómo funciona» (plan §9.9): one info callout, the limits as a second paragraph. */
export function howItWorksView(fmt: ICardFormat): IGhHostView {
  return {
    title: fmt.t('assistant.menu.howItWorks'),
    cards: [
      {
        id: 'how-it-works',
        v: 1,
        type: 'callout',
        tone: 'info',
        title: clampText(fmt.t('assistant.how.title'), 160),
        text: clampText(
          `${fmt.t('assistant.how.text')}\n\n${fmt.t('assistant.how.limits')}`,
          600
        ),
      },
    ],
  };
}
